<template>
  <div class="privacy-text">
    <h1>擎天柱Plus隐私政策</h1>
    <p>最近更新日期： 2019 年 7 月 15 日</p>
    <p>
      <strong
        >本隐私政策适用于万翼科技有限公司（以下简称“万翼科技”或“我们”）提供的擎天柱Plus产品和服务。</strong
      >擎天柱Plus以建筑信息模型系统（BIM）为载体，通过对接建筑项目（“项目”）各阶段业务系统（设计、施工、成本、采购、物业），以网站、移动应用、小程序或其他方式提供图纸和模型管理、计划任务管理、设计底线审查、成本云算量、图形引擎能力、数据中台能力、公共及项目构件库下载等服务，进行建筑全生命周期数据管理（“本服务”）。
    </p>
    <p>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
    <p>电子邮件： p-bim@vanke.com</p>
    <p>
      <strong>本政策将帮助您了解以下内容：</strong>
    </p>
    <p>
      <strong>1、我们如何收集和使用您的个人信息</strong>
    </p>
    <p>
      <strong>2、我们如何使用 Cookie 和同类技术</strong>
    </p>
    <p>
      <strong>3、我们如何共享、转让、公开披露您的个人信息</strong>
    </p>
    <p>
      <strong>4、我们如何保护您的个人信息</strong>
    </p>
    <p>
      <strong>5、您的权利</strong>
    </p>
    <p>
      <strong>6、我们如何处理儿童的个人信息</strong>
    </p>
    <p>
      <strong>7、您的个人信息如何在全球范围转移</strong>
    </p>
    <p>
      <strong>8、本政策如何更新</strong>
    </p>
    <p>
      <strong>9、如何联系我们</strong>
    </p>
    <p>
      万翼科技深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。
      <strong
        >我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。</strong
      >同时，万翼科技承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
    </p>
    <p>
      我们努力以简明、清晰、易于理解的方式展现本隐私政策。为了便于您阅读及理解，我们将涉及个人信息保护以及万翼科技业务和组织关系的专门术语进行了定义，请前往本隐私政策“附录1：定义”来了解这些术语的具体内容，以便您准确掌握我们希望向您表达的信息。
    </p>
    <p>
      <strong
        >请在使用我们的产品前，仔细阅读并了解本隐私政策，以便您更好地了解我们的产品及其提供的各项服务，并作出适当的选择。</strong
      >
    </p>
    <ol>
      <!-- 1 -->
      <li class="no-order">
        <h2>
          <div id="section1">1. 我们如何收集和使用您的个人信息</div>
        </h2>
        <p>
          万翼科技仅会出于本政策所述的以下目的，遵循合法、正当、必要的原则，收集和使用实现产品功能所必要的您的个人信息：
        </p>
        <ol>
          <!-- 1.1 -->
          <li class="number">
            <p>登录注册信息</p>
            <p>
              您需要通过账号申请程序注册一个擎天柱Plus账户或使用您已获得授权的账号登录擎天柱Plus。
            </p>
            <ol>
              <li>
                <p>
                  若您为自然人用户且您选择注册擎天柱Plus账户的，您授权我们收集和使用您的手机号码作为用户名。您还可以在注册页面或个人信息页面提供头像、姓名、电子邮箱、性别以丰富您的账号信息。补充信息如果拒绝提供并不影响您使用擎天柱Plus的基本功能。
                </p>
              </li>
              <li>
                <p>
                  如果您作为项目合作方人员经授权使用已分配的擎天柱Plus账户，您已在线下向我们提供的账户注册信息（姓名、手机号码、所属企业和电子邮箱）是我们识别身份并向您提供服务的依据，您同意我们收集和使用。
                </p>
              </li>
              <li>
                <p>
                  如果您作为万科集团雇员使用已注册的万科集团人员管理系统（“IDM”）账号登录擎天柱Plus的，您授权我们收集和使用您的IDM账号信息，包括IDM账号、您的姓名、手机号码、电子邮箱等。
                </p>
              </li>
            </ol>
            <p>
              您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息，或对您的个人信息进行匿名化处理，法律法规另有规定或您与我们另有约定的情形除外。
            </p>
          </li>
          <!-- 1.2 -->
          <li class="number">
            <p>信息发布</p>
            <p>
              擎天柱Plus为用户提供信息发布和评论功能。使用这些服务时，您的用户名、联系方式将会被查询或公开。此外，其他用户可以查看您上传发布的其他文字、视频、图片等。请您注意在信息发布时谨慎披露涉及个人的隐私性或敏感性信息。
            </p>
            <p>
              通过擎天柱Plus的评价系统，我们将收集和使用您的注册信息和评价内容，您授权我们有权对外披露。
            </p>
          </li>
          <!-- 1.3 -->
          <li class="number">
            <p>即时通讯</p>
            <p>
              擎天柱Plus针对同一项目组成员即时通讯功能。使用此服务时，您的个人信息资料（如昵称、性别、头像照片、所属企业等）将会被查询或公开。此外，同一项目组成员可以查看您上传发布的其他文字、视频、照片等。请您注意在信息发布时谨慎披露涉及个人的隐私性或敏感性信息。您的通信内容和发布内容将授权我们存储在提供相关服务的即时通讯服务商服务器上。
            </p>
          </li>
          <!-- 1.4 -->
          <li class="number">
            <p>设备权限信息</p>
            <p>
              擎天柱Plus通过手机程序和应用提供服务过程中可能需要您向我们开启设备访问权限，例如相机（摄像头）、地理位置、麦克风、蓝牙的访问权限、通讯录、应用列表等，以实现这些功能所涉及的信息的收集和使用。我们会在需要开启权限时向您说明用途并征得您的同意，您开启这些权限即代表您授权我们可以收集和使用这些信息来实现相应功能。您也可以通过设备设置取消授权，我们则无法为您提供上述与这些授权所对应的功能。
            </p>
          </li>
          <!-- 1.5 -->
          <li class="number">
            <p>我们间接获取的个人信息</p>
            <p>我们采取以下两种方式间接获取您的个人信息：</p>
            <ol>
              <!-- 1.5.1 -->
              <li class="number">
                <p>由万翼科技运营的其他产品或服务中获取</p>
                <p>
                  <strong
                    >您同意我们将万翼科技不同产品中收集的个人信息进行关联、汇集和融合。当您注册后，我们将关联同一注册账户在万翼科技系统中的个人信息，包括您的IDM账号、姓名、性别、手机号码、电子邮箱等。我们可以这种数据处理方式为您提供注册便利、或免去您多次提交个人信息的重复性操作，或进行身份和权益确认，账户安全风险防范。我们将会依据现有法律法规、规范性文件及相关国家标准的要求实施相应的制度和措施，开展个人信息安全影响评估，采取适当的个人信息保护措施，以保护融合后的个人信息数据安全。</strong
                  >
                </p>
              </li>
              <!-- 1.5.2 -->
              <li class="number">
                <p>由万翼科技之外的第三方获取</p>
                <p>
                  当我们从万翼科技之外的第三方获取您的个人信息的，包括万翼科技的关联公司以及第三方合作机构，我们将依据现有法律法规、规范性文件及相关国家标准的要求，尽合理努力核实该等第三方合作机构已获得您向我们提供个人信息的合法授权及具体授权范围和期限。若我们计划超出您的授权范围使用您的个人信息的，我们将获取您的事先同意，届时，万翼科技将作为个人信息的被授权方，就您的个人信息使用授权达成新的授权许可。
                </p>
              </li>
            </ol>
          </li>
          <!-- 1.6 -->
          <li class="number">
            <p>基于其他目的使用您的个人信息</p>
            <ol>
              <!-- 1.6.1 -->
              <li class="number">
                <p>与您沟通</p>
                <p>
                  为保障本服务（无论线上或线下）开展和质量，我们会使用您的手机号码或通过产品中的内置客服系统与您沟通。例如，我们可能与您联系，让您了解万科集团的业务最新资讯，对您使用的万科集团服务进行回访。
                </p>
              </li>
              <!-- 1.6.2 -->
              <li class="number">
                <p>开展内部审计、数据分析和研究</p>
                <ol>
                  <!-- a -->
                  <li class="alphabet">
                    <p>
                      我们将使用收集的信息在万科集团内部进行必要的内部审计。
                    </p>
                  </li>
                  <!-- b -->
                  <li class="alphabet">
                    <p>
                      我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的统计类产品，展示万科集团服务的整体全貌，分析不同群体的行为模式等。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的大数据分析信息。
                    </p>
                  </li>
                  <!-- c -->
                  <li class="alphabet">
                    <p>
                      <strong
                        >我们会基于经授权合法收集的个人信息，通过信息系统、算法等非人工自动决策技术实现标签化或画像处理，从而做出的自动决策决定（如商业化信息推送），如果您不希望参与此类定向广告信息推送，请通过第九部分的联系方式要求我们作出解释，我们也将提供适当的救济方式。</strong
                      >
                    </p>
                  </li>
                </ol>
              </li>
              <!-- 1.6.3 -->
              <li class="number">
                <p>改善万翼科技的产品或服务</p>
                <p>
                  我们可能收集您在使用本服务时的设备信息、网络信息或个人行为信息，改进万翼科技的产品和服务，进行必要的业务运营与评估、客户支持，包括：
                </p>
                <ol>
                  <!-- a -->
                  <li class="alphabet">
                    <p>
                      设备的软硬件信息。例如，设备型号、操作系统版本、唯一设备标识符、电池、信号强度等信息；软件的版本号、浏览器类型。
                    </p>
                  </li>
                  <!-- b -->
                  <li class="alphabet">
                    <p>
                      设备连接和网络状态信息，如电信运营商、使用的语言，IP地址，设备传感器数据。
                    </p>
                  </li>
                  <!-- c -->
                  <li class="alphabet">
                    <p>
                      服务使用信息。我们会通过服务日志或其他技术手段记录您使用我们产品的时间和上一次使用时间，以及您在我们的产品中查看和停留信息、页面访问量，以便我们优化产品和服务。
                    </p>
                  </li>
                </ol>
              </li>
              <!-- 1.6.4 -->
              <li class="number">
                <p>安全保障</p>
                <p>
                  我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。为了验证您提供信息的准确性和完整性，或保障您的账号安全，我们会与合法留存您的信息的国家机关、金融机构、企事业单位进行核对。
                </p>
              </li>
            </ol>
          </li>
          <!-- 1.7 -->
          <li class="number">
            <p>其他说明</p>
            <ol>
              <!-- 1.7.1 -->
              <li class="number">
                <p>
                  当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
                </p>
              </li>
              <!-- 1.7.2 -->
              <li class="number">
                <p>
                  但是，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：
                </p>
                <ol>
                  <!-- a -->
                  <li class="alphabet">
                    <p>
                      与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；
                    </p>
                  </li>
                  <!-- b -->
                  <li class="alphabet">
                    <p>与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
                  </li>
                  <!-- c -->
                  <li class="alphabet">
                    <p>
                      出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
                    </p>
                  </li>
                  <!-- d -->
                  <li class="alphabet">
                    <p>所收集的个人信息是您自行向社会公众公开的；</p>
                  </li>
                  <!-- e -->
                  <li class="alphabet">
                    <p>
                      从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
                    </p>
                  </li>
                  <!-- f -->
                  <li class="alphabet">
                    <p>根据您要求签订和履行合同所必需的；</p>
                  </li>
                  <!-- g -->
                  <li class="alphabet">
                    <p>
                      用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
                    </p>
                  </li>
                  <!-- h -->
                  <li class="alphabet">
                    <p>为开展合法的新闻报道所必需的；</p>
                  </li>
                  <!-- i -->
                  <li class="alphabet">
                    <p>
                      出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
                    </p>
                  </li>
                  <!-- j -->
                  <li class="alphabet">
                    <p>法律法规规定的其他情形。</p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <!-- 2 -->
      <li class="no-order">
        <h2>
          <div id="section2">2. 我们如何使用 Cookie 和同类技术</div>
        </h2>
        <ol>
          <!-- 2.1 -->
          <li class="number">
            <p>Cookie</p>
            <ol>
              <!-- 2.1.1 -->
              <li class="number">
                <p>
                  我们会在您的计算机或移动设备上存储名为 Cookie
                  的小数据文件。Cookie
                  通常包含标识符、站点名称以及一些号码和字符。借助于
                  Cookie，网站能够存储您的偏好，为您提供更个性化的用户体验和服务。
                </p>
              </li>
              <!-- 2.1.2 -->
              <li class="number">
                <p>
                  我们不会将 Cookie
                  用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
                  Cookie。有关详情，请参见 AboutCookies.org。
                </p>
              </li>
              <!-- 2.1.3 -->
              <li class="number">
                <p>
                  您可以清除计算机上保存的所有
                  Cookie，大部分网络浏览器都设有阻止 Cookie
                  的功能，您可在您使用的浏览器设置中了解和设置。
                </p>
              </li>
            </ol>
          </li>
          <!-- 2.2 -->
          <li class="number">
            <p>Do Not Track（请勿追踪）</p>
            <ol>
              <!-- 2.2.1 -->
              <li class="number">
                <p>
                  很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do
                  Not Track
                  请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了
                  Do Not Track，那么我们的所有网站都会尊重您的选择。
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <!-- 3 -->
      <li class="no-order">
        <h2>
          <div id="section3">3. 我们如何共享、转让、公开披露您的个人信息</div>
        </h2>
        <ol>
          <!-- 3.1 -->
          <li class="number">
            <p>共享</p>
            <ol>
              <!-- 3.1.1 -->
              <li class="number">
                <p>
                  我们不会与万翼科技以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：
                </p>
                <ol>
                  <!-- a -->
                  <li class="alphabet">
                    <p>
                      根据您使用本服务中的指示，在获取明确同意的情况下共享。
                    </p>
                  </li>
                  <!-- b -->
                  <li class="alphabet">
                    <p>
                      与我们的关联公司共享：您的个人信息可能会与万翼科技的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。例如：我们将为您的流程监控服务目的，与您所在项目所属的关联公司共享您的注册信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
                      我们的关联公司的定义和范围，请见附录。
                    </p>
                  </li>
                  <!-- c -->
                  <li class="alphabet">
                    <p>
                      与授权合作伙伴共享：仅为实现本服务具体功能的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，为我们提供短消息服务的供应商，我们会共享您的手机号码信息；为我们提供即时通信服务的供应商，我们会共享您的账户信息和通讯内容等。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
                    </p>
                  </li>
                  <!-- d -->
                  <li class="alphabet">
                    <p>
                      我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
                    </p>
                  </li>
                </ol>
              </li>
              <!-- 3.1.2 -->
              <li class="number">
                <p>
                  对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
                </p>
              </li>
              <!-- 3.1.3 -->
              <li class="number">
                <p>
                  为避免歧义，您应知悉并了解，
                  <strong
                    >相关产品中可能含有其他独立第三方运营的网站、应用程序、产品和服务的链接，我们对此第三方网站、应用程序、产品和服务不作任何明示和默示的保证，该类链接仅为方便用户浏览相关页面而提供。当您访问该等第三方网站、应用程序、产品和服务链接时，应另行同意其为您提供的隐私政策或个人信息保护条款。我们与该等第三方网站、应用程序、产品和服务提供者在法律规定和双方约定的范围内各自向您承担独立的个人信息保护责任。</strong
                  >
                </p>
              </li>
            </ol>
          </li>
          <!-- 3.2 -->
          <li class="number">
            <p>转让</p>
            <p>
              我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
            </p>
            <ol>
              <!-- 3.2.1 -->
              <li class="number">
                <p>
                  在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
                </p>
              </li>
              <!-- 3.2.2 -->
              <li class="number">
                <p>
                  在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
                </p>
              </li>
            </ol>
          </li>
          <!-- 3.3 -->
          <li class="number">
            <p>公开披露</p>
            <p>
              为项目组沟通的需要，我们会在项目组成员中公开您的账户信息和联系方式。除此以外，我们仅会在以下情况下，公开披露您的个人信息：
            </p>
            <ol>
              <!-- 3.3.1 -->
              <li class="number">
                <p>获得您明确同意后；</p>
              </li>
              <!-- 3.3.2 -->
              <li class="number">
                <p>
                  基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <!-- 4 -->
      <li class="no-order">
        <h2>
          <div id="section4">4. 我们如何保护您的个人信息</div>
        </h2>
        <ol>
          <!-- 4.1 -->
          <li class="number">
            <p>
              我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的设备与
              “服务器”之间交换数据（如信用卡信息）时受
              ADS、HTTPS加密保护；我们同时会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
            </p>
          </li>
          <!-- 4.2 -->
          <li class="number">
            <p>我们已经取得了ISO27001（2013版）国际信息安全认证。</p>
          </li>
          <!-- 4.3 -->
          <li class="number">
            <p>
              我们的数据安全能力：万翼科技有强大的信息安全部门为万翼科技的产品构建完整先进的数据安全保护体系，包括对用户信息进行识别、加密保存、数据访问权限划分；制定了内部数据管理制度和操作规程，从数据的获取、使用、销毁都有严格的流程要求，避免用户隐私数据被非法使用；确定接触用户个人信息的各部门及其负责人安全管理责任；建立用户个人信息收集、使用及其相关活动的工作流程和安全管理制度；
              对工作人员及代理人实行权限管理，对批量导出、复制、销毁个人信息实行审查，并采取防泄密措施；
              妥善保管记录用户个人信息的纸介质、光介质、电磁介质等载体，并采取相应的安全储存措施；对储存用户个人信息的信息系统实行接入审查，并采取防入侵、防病毒等措施；记录对用户个人信息进行操作的人员、时间、地点、事项等信息；定期举办安全和隐私保护培训，提高员工的个人信息保护意识。
            </p>
          </li>
          <!-- 4.4 -->
          <li class="number">
            <p>
              我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在本隐私政策所述目的所需的期限内保留您的个人信息，除非征得您的同意需要延长保留期或受到法律的允许。
            </p>
          </li>
          <!-- 4.5 -->
          <li class="number">
            <p>
              互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
            </p>
          </li>
          <!-- 4.6 -->
          <li class="number">
            <p>
              在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
            </p>
          </li>
        </ol>
        <p>
          同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
        </p>
        <p>
          若您发现您的个人信息泄露时，请您立即通过本隐私政策约定的联系方式与我们联系，以便我们及时采取相应措施。
        </p>
      </li>

      <!-- 5 -->
      <li class="no-order">
        <h2>
          <div id="section5">5. 您的权利</div>
        </h2>
        <p>
          如果您为项目合作方注册账户，若您希望行使如下权利，请您自行或通过所在机构与项目方联系，通过项目方确认身份并在法律法规要求和您的合约义务范围内最大程度保障您的权利。
        </p>
        <p>
          如果您的账户系万科集团内部雇员账户，若您希望行使如下权利，请您与人事部门联系，您的相关要求应不违反IDM系统现有管理制度和规则，且与您的IDM账户现状不存在冲突。
        </p>
        <p>
          对于普通注册用户，我们将按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，努力保障您对自己的个人信息行使以下权利：
        </p>
        <ol>
          <!-- 5.1 -->
          <li class="number">
            <p>访问您的个人信息</p>
            <ol>
              <!-- 5.1.1 -->
              <li class="number">
                <p>您有权访问您的个人信息</p>
                <ol>
                  <!-- a -->
                  <li class="alphabet">
                    <p>
                      您可以进入“擎天柱Plus-个人中心”，查看个人信息，包括用户名、手机号码、电子邮箱、姓名、性别、收藏/下载情况。
                    </p>
                  </li>
                </ol>
              </li>
              <!-- 5.1.2 -->
              <li class="number">
                <p>
                  如果您无法通过前述途径访问个人信息，您可以随时通过第九部分的联系方式联系我们，我们将在合理期限内回复您的访问请求。
                </p>
              </li>
            </ol>
          </li>
          <!-- 5.2 -->
          <li class="number">
            <p>更正您的个人信息</p>
            <ol>
              <!-- 5.2.1 -->
              <li class="number">
                <p>
                  当您发现我们处理的关于您的个人信息有错误时，您可以进入“擎天柱Plus-个人中心”，修改个人信息，包括用户名、电子邮箱、姓名、性别。手机号码作为您的用户名不可自行修改，请您另行注册新账户申请导入原用户名下信息或通过第九部分的联系方式联系我们。
                </p>
              </li>
              <!-- 5.2.2 -->
              <li class="number">
                <p>
                  如果您无法通过前述途径更正这些个人信息，您可以随时通过第九部分的联系方式联系我们，我们将在合理期限内回复您的更正请求。
                </p>
              </li>
            </ol>
          </li>
          <!-- 5.3 -->
          <li class="number">
            <p>删除您的个人信息</p>
            <ol>
              <!-- 5.3.1 -->
              <li class="number">
                <p>
                  在以下情形中，您可以随时通过第九部分的联系方式联系我们，向我们提出删除个人信息的请求：
                </p>
                <ol>
                  <!-- a -->
                  <li class="alphabet">
                    <p>如果我们处理个人信息的行为违反法律法规；</p>
                  </li>
                  <!-- b -->
                  <li class="alphabet">
                    <p>如果我们收集、使用您的个人信息，却未征得您的同意；</p>
                  </li>
                  <!-- c -->
                  <li class="alphabet">
                    <p>如果我们处理个人信息的行为违反了与您的约定；</p>
                  </li>
                  <!-- d -->
                  <li class="alphabet">
                    <p>如果您不再使用我们的产品或服务，或您注销了账号；</p>
                  </li>
                  <!-- e -->
                  <li class="alphabet">
                    <p>如果我们不再为您提供产品或服务。</p>
                  </li>
                </ol>
              </li>
              <!-- 5.3.2 -->
              <li class="number">
                <p>
                  若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
                </p>
              </li>
              <!-- 5.3.3 -->
              <li class="number">
                <p>
                  当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
                </p>
              </li>
            </ol>
          </li>
          <!-- 5.4 -->
          <li class="number">
            <p>改变您授权同意的范围</p>
            <ol>
              <!-- 5.4.1 -->
              <li class="number">
                <p>
                  对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意
                </p>
              </li>
              <!-- 5.4.2 -->
              <li class="number">
                <p>
                  您可以通过更改手机设备中的相机等访问权限或更改浏览器功能设置、更改产品的设置选项，或者向我们第九部分的联系方式发送通知的方式改变授权同意的范围。
                </p>
              </li>
              <!-- 5.4.3 -->
              <li class="number">
                <p>
                  当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
                </p>
              </li>
              <!-- 5.4.4 -->
              <li class="number">
                <p>
                  <strong
                    >特别地，如果您不想接受我们给您发送的商业性促销信息，您可通过短信息或邮件上明确告知的退订方式回复取消推送或联系我们。</strong
                  >
                </p>
              </li>
            </ol>
          </li>
          <!-- 5.5 -->
          <li class="number">
            <p>个人信息主体注销账户</p>
            <ol>
              <!-- 5.5.1 -->
              <li class="number">
                <p>
                  您随时通过第九部分的联系方式申请注销账户。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。
                </p>
              </li>
              <!-- 5.5.2 -->
              <li class="number">
                <p>
                  请注意，若您在注销时存在需要您履行义务的事宜，且在法律法规允许的范围内，您的注销申请不会被立即支持。当您确认注销成功后，账户信息、个人身份信息、下载记录、会员权益等将无法恢复或提供；但您仍应对您在注销账号前且使用平台服务期间的行为承担相应责任。
                </p>
              </li>
            </ol>
          </li>
          <!-- 5.6 -->
          <li class="number">
            <p>个人信息主体获取个人信息副本</p>
            <ol>
              <!-- 5.6.1 -->
              <li class="number">
                <p>
                  您有权获取您的个人信息副本，若我们有获取您的个人基本资料、个人身份信息、个人健康生理信息和个人教育工作信息，您可以通过联系我们索要上述信息的副本。
                </p>
              </li>
              <!-- 5.6.2 -->
              <li class="number">
                <p>
                  在技术可行的前提下，例如数据接口匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。
                </p>
              </li>
            </ol>
          </li>
          <!-- 5.7 -->
          <li class="number">
            <p>响应您的上述请求</p>
            <ol>
              <!-- 5.7.1 -->
              <li class="number">
                <p>
                  为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
                </p>
              </li>
              <!-- 5.7.2 -->
              <li class="number">
                <p>
                  一般情况下我们将在三十天内回复您的权利请求。如您不满意，还可以通过第九部分的联系方式进行投诉。
                </p>
              </li>
              <!-- 5.7.3 -->
              <li class="number">
                <p>
                  对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
                </p>
              </li>
              <!-- 5.7.4 -->
              <li class="number">
                <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
                <ol>
                  <!-- a -->
                  <li class="alphabet">
                    <p>与国家安全、国防安全直接相关的；</p>
                  </li>
                  <!-- b -->
                  <li class="alphabet">
                    <p>与公共安全、公共卫生、重大公共利益直接相关的；</p>
                  </li>
                  <!-- c -->
                  <li class="alphabet">
                    <p>与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
                  </li>
                  <!-- d -->
                  <li class="alphabet">
                    <p>有充分证据表明您存在主观恶意或滥用权利的；</p>
                  </li>
                  <!-- e -->
                  <li class="alphabet">
                    <p>
                      响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
                    </p>
                  </li>
                  <!-- f -->
                  <li class="alphabet">
                    <p>涉及商业秘密的。</p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <!-- 6 -->
      <li class="no-order">
        <h2>
          <div id="section6">6. 我们如何处理儿童的个人信息</div>
        </h2>
        <ol>
          <!-- 6.1 -->
          <li class="number">
            <p>
              <strong
                >我们的服务仅限16岁以上的用户使用，如果您未满16周岁，请您立即停止使用我们的服务。您应明确了解，若我们在服务过程中发现或怀疑您未满16周岁的，则我们可以随时中止或终止向您提供服务，直至您向我们提供您已满16周岁的证明。</strong
              >
            </p>
          </li>
          <!-- 6.2 -->
          <li class="number">
            <p>
              <strong
                >在此情形下，如果我们发现收集了未满16周岁的儿童的个人信息，则会尽快删除相关数据</strong
              >
            </p>
          </li>
        </ol>
      </li>
      <!-- 7 -->
      <li class="no-order">
        <h2>
          <div id="section7">7. 您的个人信息如何在全球范围转移</div>
        </h2>
        <ol>
          <!-- 7.1 -->
          <li class="number">
            <p>
              <strong
                >原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</strong
              >
            </p>
          </li>
          <!-- 7.2 -->
          <li class="number">
            <p>
              <strong
                >由于我们产品可能被境外主体使用，这意味着，在我们的产品由境外主体使用时，您知悉并同意您的个人信息被您所在国家/地区之外的管辖区存储、收集和使用。此类管辖区或数据主体可能适用不同的数据保护法，我们将遵循相关法律法规的要求，确保您的个人信息得到在中华人民共和国境内足够同等的保护。</strong
              >
            </p>
          </li>
        </ol>
      </li>
      <!-- 8 -->
      <li class="no-order">
        <h2>
          <div id="section8">8. 本政策如何更新</div>
        </h2>
        <ol>
          <!-- 8.1 -->
          <li class="number">
            <p>
              请您理解，由于擎天柱Plus向您提供的功能和服务是不断更新和发展的，我们将努力贯彻“隐私保护设计”的理念，完善我们的产品设计，通过页面提示、公告或交互流程等方式及时向您说明个人信息收集的内容、范围和目的，作为本隐私政策的必要补充。
            </p>
          </li>
          <!-- 8.2 -->
          <li class="number">
            <p>
              <strong
                >未经您明确同意，我们不会削减您按照隐私政策所应享有的权利。</strong
              >我们会发布对隐私政策的更新版本。
              对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。
            </p>
          </li>
          <!-- 8.3 -->
          <li class="number">
            <p>隐私政策的重大变更包括但不限于：</p>
            <ol>
              <!-- 8.3.1 -->
              <li class="number">
                <p>
                  我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
                </p>
              </li>
              <!-- 8.3.2 -->
              <li class="number">
                <p>
                  我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
                </p>
              </li>
              <!-- 8.3.3 -->
              <li class="number">
                <p>个人信息共享、转让或公开披露的主要对象发生变化；</p>
              </li>
              <!-- 8.3.4 -->
              <li class="number">
                <p>您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
              </li>
              <!-- 8.3.5 -->
              <li class="number">
                <p>
                  我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
                </p>
              </li>
              <!-- 8.3.6 -->
              <li class="number">
                <p>个人信息安全影响评估报告表明存在高风险时。</p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <!-- 9 -->
      <li class="no-order">
        <h2>
          <div id="section9">9. 如何联系我们</div>
        </h2>
        <ol>
          <!-- 9.1 -->
          <li class="number">
            <p>
              如果您对隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：
              p-bim@vanke.com
            </p>
          </li>
          <!-- 9.2 -->
          <li class="number">
            <p>
              <strong
                >我们设立了个人信息保护专员，您可以通过以下方式与其联系，一般情况下，我们将在十五天内回复。</strong
              >
            </p>
            <p>
              <strong>万翼科技有限公司</strong>
            </p>
            <p>
              <strong>联系地址：深圳市南山区粤兴六道中科纳能大厦6A、6B</strong>
            </p>
            <p>
              <strong>个人信息保护专员：p-fwgzyx@vanke.com</strong>
            </p>
          </li>
          <!-- 9.3 -->
          <li class="number">
            <p>
              <strong
                >如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，且协商无法达成一致的，任何一方均可将有关争议提交至深圳国际仲裁院（深圳仲裁委员会）并按照其届时有效的仲裁规则仲裁；仲裁裁决是终局的，对各方均有约束力。</strong
              >
            </p>
          </li>
        </ol>
      </li>
      <!-- 10 -->
      <li class="no-order">
        <h2>
          <div id="section10">10. 擎天柱Plus APP 接入第三方SDK目录</div>
        </h2>
        <ol>
          <!-- 10.1 -->
          <li>
            <p @click="navToSdk()">
              <img class="sdk" src="../../../assets/images/sdk.jpg" alt="" />
            </p>
          </li>
        </ol>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  methods: {
    navToSdk() {
      window.location.href = 'https://developers.facebook.com/'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/content.scss';
.sdk {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/privacyCloud/components/privacyContent.vue